import generateWithAsyncActions from 'epic-alt-utils';
import {alt} from 'epic-react-common';

/**
 * WatchActions
 */
export default generateWithAsyncActions(
  alt,
  [
    'getFeatured',
    'getCategories',
    'getCategory',
    'getAssetDetail',
    'getFoundersPacks',
    'getSubscriptionData',
    'refreshAsset',
    'sendWelcome',
    'closePopDown',
  ],
  ['clearCaches']
);
